import React from "react";
import "../scss/loadingScreen.scss";

export default function LoadingScreen() {
    return (
        <div className="site-loader" role="status" aria-live="polite" aria-label="Loading IT Tech European website">
            <div className="site-loader__content">
                <div className="site-loader__ring" aria-hidden="true" />
                <h1 className="site-loader__brand">
                    <span>IT</span> <span>Tech</span> <span>European</span>
                </h1>
                <p className="site-loader__tagline">Building modern digital experiences</p>
            </div>
        </div>
    );
}
